import { RouteErrorBoundary } from "~/domain/user-session"
import { page } from "~/shared/ui/page"
import { MainTemplate } from "~/templates/main"


export const routes = [
	{
		element: <MainTemplate />,
		children: [
			{
				path: "user",
				lazy: page(() => import('./pages/user')),
				ErrorBoundary: RouteErrorBoundary
			},
			{
				path: "admin",
				lazy: page(() => import('./pages/admin')),
				ErrorBoundary: RouteErrorBoundary
			}
		]
	}
]